import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import VueWindowSize from 'vue-window-size'
import VueRouter from 'vue-router'
import './plugins/dayjs'

Vue.use(VueWindowSize)
Vue.use(VueRouter)

Vue.config.productionTip = false

new Vue({
  store,
  vuetify,
  router: new VueRouter({ mode: 'history', base: new URL(window.APPLICATION.exposedUrl).pathname }),
  render: h => h(App)
}).$mount('#app')
